module.exports = __webpack_public_path__ + "26bd867dd65e26dbc77d1e151ffd36e0.png";